export enum EVENTS {
	FAIL = 'fail',
	SUCCESS = 'success',
	FINISH = 'finish',
}
